import MainLayout from "layouts/MainLayout/MainLayout";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useCitizenContext } from "../Context";
import { getCitizen, getCitizenByCardNumber } from "services/citizen";
import { styled } from "styled-components";
import { Divider } from "antd";
import Title from "antd/lib/typography/Title";
import RedeemForm from "../components/RedeemForm";
import { MobileContainer } from "../components/reusables";
import { CitizenDetailHeader } from "../components/citizenDetailHeader";

const CitizenProfileContainer = styled(MobileContainer)`
  z-index: 2;
  position: relative;
`;
const StyledElement = styled.div`
  @media only screen and (min-width: 768px) {
    background: none;
    padding-top: 0px;
    box-shadow: none;
    margin-top: 0px;
  }
`;

const StyledDivider = styled(Divider)`
  margin: 0px !important;

  @media only screen and (min-width: 700px) {
    border-top: 1px solid white !important;
  }
`;

const StyledTitle = styled(Title)`
  margin-bottom: 0px !important;
`;

const Redeeem = () => {
  const { id } = useParams();

  if (!id) {
    throw Error("No ID provided");
  }

  return (
    <StyledElement>
      <CitizenDetailHeader />
      <CitizenProfileContainer>
        <MainLayout>
          <StyledTitle level={3}>Social Service</StyledTitle>
          <StyledDivider />
          <RedeemForm />
        </MainLayout>
      </CitizenProfileContainer>
    </StyledElement>
  );
};

export default Redeeem;
